import { ChoiceGroup } from "@fluentui/react/lib/ChoiceGroup";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { WithTranslator } from "Components/Generic/Translator";
import { WithProjectItemContext } from "../ProjectItemContext/WithProjectItemContext";
import { useContent } from "./Hooks/UseContent";
import { IContentProps } from "./IContentProps";
import { useContentStyles } from "./UseContentStyles";

export const Content = WithTheme(
  WithProjectItemContext(
    WithTranslator((props: IContentProps): JSX.Element => {
      const {
        selectedResultItemId,
        translator,
        theme: { spacing }
      } = props;
      const { hasResults, options, onChangeChoice } = useContent(props);
      const styles = useContentStyles();
      return (
        <Stack grow className={styles.root} tokens={{ childrenGap: spacing.s1 }}>
          {hasResults
            ? (
              <Stack.Item>
                <ChoiceGroup
                  options={options}
                  onChange={onChangeChoice}
                  selectedKey={selectedResultItemId}
                  className={styles.choices}
                />
              </Stack.Item>
            )
            : (
              <Text>{translator.get(`generic.noresults`, `No results found~...`)}</Text>
            )}
        </Stack>
      );
    })
  )
);
